module.exports = __webpack_public_path__ + "img/product-placeholder-18.b9b66f9.png";